module.exports = __webpack_public_path__ + "img/others.2b08e0dc.svg";